// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HIhCa","modal":"Modal_modal__BDix1","slide-down":"Modal_slide-down__ufunn"};